import { SerialNumberElasticDto } from "../models"

const selectSerialNumbers = state => state.listing.serialNumbers


export const productSerialNumbersSelector = (state) : Array<SerialNumberElasticDto> => selectSerialNumbers(state).listing




// WEBPACK FOOTER //
// ./src/state/listing/serial-numbers/selectors/selectors.ts